/* eslint-disable */
import React, { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import { useTranslation } from "react-i18next";

import * as url from "helper/UrlHelper";
import { getData, postData, putData, uploadMultipleFile } from "utils/Gateway";

import { reactSelectStyle } from "Config/Config";

// Move ParameterBlock component outside to prevent re-rendering issues
const ParameterBlock = ({
  parameter,
  index,
  updateParameter,
  removeParameter,
}) => {
  const accordionId = `parameter-accordion-${index}`;
  const collapseId = `parameter-collapse-${index}`;
  const headingId = `heading-${index}`;

  return (
    <div className="accordion mb-3" id={accordionId}>
      <div className="accordion-item border border-gray-300 rounded-8 shadow-sm">
        <h6
          className="accordion-header d-flex align-items-center"
          id={headingId}
        >
          <button
            className="accordion-button collapsed bg-light fw-semibold py-3 px-3 border-0 rounded-top-8 flex-grow-1"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#${collapseId}`}
            aria-expanded="false"
            aria-controls={collapseId}
          >
            <div className="d-flex align-items-center w-100">
              <span className="text-primary me-2">Parameter {index + 1}</span>
              {parameter.parameterName && (
                <span className="text-muted">- {parameter.parameterName}</span>
              )}
            </div>
          </button>
          <button
            type="button"
            className="btn btn-sm btn-outline-danger ms-2 me-3 d-flex align-items-center"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              removeParameter(index);
            }}
            title="Remove Parameter"
            style={{ minWidth: "32px", height: "32px" }}
          >
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "16px" }}
            >
              delete
            </span>
          </button>
        </h6>
        <div
          id={collapseId}
          className="accordion-collapse collapse"
          aria-labelledby={headingId}
          data-bs-parent={`#${accordionId}`}
        >
          <div className="accordion-body p-3 bg-white">
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="d-block fw-semibold mb-2">Parameter ID</label>
                <input
                  type="text"
                  value={parameter.parameterId}
                  onChange={(e) =>
                    updateParameter(index, "parameterId", e.target.value)
                  }
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder="Enter Parameter ID"
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="d-block fw-semibold mb-2">
                  Parameter Name *
                </label>
                <input
                  type="text"
                  value={parameter.parameterName}
                  onChange={(e) =>
                    updateParameter(index, "parameterName", e.target.value)
                  }
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder="Enter Parameter Name"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 mb-3">
                <label className="d-block fw-semibold mb-2">LOINC Code</label>
                <input
                  type="text"
                  value={parameter.loincCode}
                  onChange={(e) =>
                    updateParameter(index, "loincCode", e.target.value)
                  }
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder="Enter LOINC Code"
                />
              </div>
              <div className="col-md-4 mb-3">
                <label className="d-block fw-semibold mb-2">Unit</label>
                <input
                  type="text"
                  value={parameter.unit}
                  onChange={(e) =>
                    updateParameter(index, "unit", e.target.value)
                  }
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder="Enter Unit"
                />
              </div>
              <div className="col-md-4 mb-3">
                <label className="d-block fw-semibold mb-2">Sample Type</label>
                <input
                  type="text"
                  value={parameter.sampleType}
                  onChange={(e) =>
                    updateParameter(index, "sampleType", e.target.value)
                  }
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder="e.g., blood, urine"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 mb-3">
                <label className="d-block fw-semibold mb-2">Methodology</label>
                <input
                  type="text"
                  value={parameter.methodology}
                  onChange={(e) =>
                    updateParameter(index, "methodology", e.target.value)
                  }
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder="e.g., spectrophotometry"
                />
              </div>
            </div>

            <div className="border-top pt-3">
              <h6 className="fw-semibold mb-3">Reference Range</h6>
              <div className="row">
                <div className="col-md-3 mb-3">
                  <label className="d-block fw-semibold mb-2">Min</label>
                  <input
                    type="number"
                    step="any"
                    value={parameter.referenceRange.min || ""}
                    onChange={(e) =>
                      updateParameter(
                        index,
                        "referenceRange.min",
                        parseFloat(e.target.value) || null
                      )
                    }
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder="Min value"
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label className="d-block fw-semibold mb-2">Max</label>
                  <input
                    type="number"
                    step="any"
                    value={parameter.referenceRange.max || ""}
                    onChange={(e) =>
                      updateParameter(
                        index,
                        "referenceRange.max",
                        parseFloat(e.target.value) || null
                      )
                    }
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder="Max value"
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label className="d-block fw-semibold mb-2">
                    Measuring Unit
                  </label>
                  <input
                    type="text"
                    value={parameter.referenceRange.measuringunit}
                    onChange={(e) =>
                      updateParameter(
                        index,
                        "referenceRange.measuringunit",
                        e.target.value
                      )
                    }
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder="e.g., µL, mL"
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label className="d-block fw-semibold mb-2">
                    Normal Range
                  </label>
                  <input
                    type="text"
                    value={parameter.referenceRange.normal}
                    onChange={(e) =>
                      updateParameter(
                        index,
                        "referenceRange.normal",
                        e.target.value
                      )
                    }
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder="e.g., 4.5-5.5 x10^6/µL"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label className="d-block fw-semibold mb-2">Note</label>
                  <textarea
                    rows="2"
                    value={parameter.referenceRange.note}
                    onChange={(e) =>
                      updateParameter(
                        index,
                        "referenceRange.note",
                        e.target.value
                      )
                    }
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder="Additional notes"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SaveLabTestTemplatePopup = ({
  selectedLabTestId,
  setSelectedLabTestId,
  afterActionClose,
}) => {
  const token = localStorage.getItem("token");
  const { t } = useTranslation();

  // Add loading state for data fetching
  const [isLoadingData, setIsLoadingData] = useState(false);

  // Define states for all input fields - Updated according to model
  const [loincCodeValue, setLoincCodeValue] = useState(null);
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [loincCode, setLoincCode] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState(null);
  const [preparationInstructions, setPreparationInstructions] = useState("");
  const [duration, setDuration] = useState("");
  const [requiresFasting, setRequiresFasting] = useState(false);
  const [sampleType, setSampleType] = useState("");
  const [parameters, setParameters] = useState([]);

  // Keep existing fields for backward compatibility
  const [orderDate, setOrderDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [testDate, setTestDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [resultDate, setResultDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [result, setResult] = useState("");
  const [unit, setUnit] = useState("");
  const [referenceRange, setReferenceRange] = useState("");
  const [severity, setSeverity] = useState(null);
  const [comments, setComments] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  // Test Status options
  const testStatusOptions = [
    { label: "Assigned", value: "Assigned" },
    { label: "Test Pending", value: "Test Pending" },
    { label: "Sample Collected", value: "Sample Collected" },
    { label: "Report Generated", value: "Report Generated" },
    { label: "Report Delivered", value: "Report Delivered" },
    { label: "Cancelled", value: "Cancelled" },
  ];

  // Add state for test status
  const [testStatus, setTestStatus] = useState(null);

  // File upload states
  const [docFileUploading, setDocFileUploading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]); // Array of uploaded file objects

  // Add new states for priority and testresult
  const [priority, setPriority] = useState(null);
  const [testResult, setTestResult] = useState(null);

  // Priority options
  const priorityOptions = [
    { label: "Normal", value: "normal" },
    { label: "Urgent", value: "urgent" },
    { label: "STAT", value: "stat" },
  ];

  // Test Result options
  const testResultOptions = [
    { label: "Normal", value: "Normal" },
    { label: "Positive", value: "Positive" },
    { label: "Negative", value: "Negative" },
    { label: "Abnormal", value: "Abnormal" },
    { label: "Critical", value: "Critical" },
    { label: "Borderline", value: "Borderline" },
    { label: "Inconclusive", value: "Inconclusive" },
  ];

  // LOINC options
  const loadLoincOptions = async (inputValue) => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_LOINC_CODES +
        `?token=${token}&searchquery=${inputValue}`;

      const response = await getData(requestUrl);

      return response.data;
    } catch (error) {
      return [];
    }
  };

  // Async load options for test categories
  const loadCategoryOptions = async (inputValue) => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_CATEGORIES + // You'll need to add this endpoint
        `?token=${token}&slug=lab-test-type`;

      const response = await getData(requestUrl);
      return response.data.map((category) => ({
        value: category._id,
        label: category.name,
      }));
    } catch (error) {
      return [];
    }
  };

  //function for file upload (multiple)
  const uploadHandler = async (files) => {
    try {
      setDocFileUploading(true);
      let requestUrl =
        url.API_BASE_URL + url.API_MULTIPLE_FILE_UPLOAD + `?token=${token}`;

      const response = await uploadMultipleFile(requestUrl, files);
      if (response.status) {
        setUploadedFiles((prev) => [...prev, ...response.data]);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setDocFileUploading(false);
    }
  };

  //function for delete file from upload stack
  const closeDocFileHandler = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  //function for get lab test details
  const getLabTestDetails = async () => {
    try {
      setIsLoadingData(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_MEDICAL_TEST_BY_ID +
        `/${selectedLabTestId}?token=${token}`;

      console.log("Fetching Lab Test from URL:", requestUrl);

      const response = await getData(requestUrl);

      if (response.status) {
        const labTestData = response.data;

        // Map new model fields
        setName(labTestData.name || "");
        setCode(labTestData.code || "");
        setLoincCode(labTestData.loinccode || "");
        setDescription(labTestData.description || "");
        setPreparationInstructions(labTestData.preparationInstructions || "");
        setDuration(labTestData.duration || "");
        setRequiresFasting(labTestData.requiresFasting || false);
        setSampleType(labTestData.sampleType || "");
        setParameters(labTestData.parameters || []);

        // Map category field - Updated to handle API response structure
        if (
          labTestData.category &&
          typeof labTestData.category === "object" &&
          labTestData.category._id
        ) {
          setCategory({
            value: labTestData.category._id,
            label: labTestData.category.name,
          });
        } else if (labTestData.categoryvalue && labTestData.categorylabel) {
          setCategory({
            value: labTestData.categoryvalue,
            label: labTestData.categorylabel,
          });
        } else if (
          labTestData.category &&
          typeof labTestData.category === "string"
        ) {
          setCategory({
            value: labTestData.category,
            label: labTestData.category,
          });
        }

        // Map existing fields for backward compatibility
        setOrderDate(
          labTestData.orderdate
            ? new Date(labTestData.orderdate).toISOString().split("T")[0]
            : ""
        );
        setTestDate(
          labTestData.testdate
            ? new Date(labTestData.testdate).toISOString().split("T")[0]
            : ""
        );
        setResultDate(
          labTestData.resultdate
            ? new Date(labTestData.resultdate).toISOString().split("T")[0]
            : ""
        );
        setResult(labTestData.result);
        setUnit(labTestData.unit);
        setReferenceRange(labTestData.referencerange);
        setSeverity({
          value: labTestData.severity,
          label: labTestData.severity,
        });
        setComments(labTestData.comments);
        setTestStatus(
          labTestData.teststatus
            ? { value: labTestData.teststatus, label: labTestData.teststatus }
            : null
        );
        // If there are uploaded files, set them
        if (
          labTestData.uploadedfiles &&
          Array.isArray(labTestData.uploadedfiles)
        ) {
          setUploadedFiles(labTestData.uploadedfiles);
        }

        // Map new fields
        setPriority(
          labTestData.priority
            ? {
                value: labTestData.priority,
                label:
                  labTestData.priority.charAt(0).toUpperCase() +
                  labTestData.priority.slice(1),
              }
            : null
        );
        setTestResult(
          labTestData.testresult
            ? { value: labTestData.testresult, label: labTestData.testresult }
            : null
        );
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoadingData(false);
    }
  };

  //function for save lab test
  const saveLabTestTemplateHandler = async () => {
    try {
      setIsSaving(true);
      const apiData = {
        // New model fields
        istemplate: true,
        name: name,
        code: code,
        loinccode: loincCode,
        description: description,
        category: category ? category.value : null,
        preparationInstructions: preparationInstructions,
        duration,

        requiresFasting: requiresFasting,
        sampleType: sampleType,
        parameters: parameters,

        // Existing fields for backward compatibility
        orderdate: orderDate,
        testdate: testDate,
        resultdate: resultDate,

        result: result,
        unit: unit,
        referencerange: referenceRange,
        severity: severity?.value,
        comments: comments,
        assignto: null,
        doctorid: null,
        clinicid: null,
        teststatus: testStatus ? testStatus.value : "",
        uploads: uploadedFiles.map((f) => f._id),

        // Add new fields
        priority: priority?.value,
        testresult: testResult?.value,
      };

      console.log("apiData", apiData);

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (selectedLabTestId) {
        requestUrl +=
          url.API_UPDATE_MEDICAL_TEST + `/${selectedLabTestId}?token=${token}`;
        response = await putData(requestUrl, apiData);
      } else {
        requestUrl += url.API_ADD_MEDICAL_TEST + `?token=${token}`;

        response = await postData(requestUrl, apiData);
      }

      console.log(response);

      if (response.status) {
        //close offcanvas
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#saveLabTestTemplateOffCanvas")
        ).hide();
        resetHandler();
        afterActionClose([response.data]);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsSaving(false);
    }
  };

  // Add new parameter to the array
  const addParameter = () => {
    const newParameter = {
      parameterId: "",
      parameterName: "",
      loincCode: "",
      unit: "",
      obtainedValue: null,
      interpretation: "",
      referenceRange: {
        min: null,
        max: null,
        measuringunit: "",
        normal: "",
        note: "",
      },
      sampleType: "",
      methodology: "",
    };
    setParameters([...parameters, newParameter]);
  };

  // Remove parameter from array
  const removeParameter = (index) => {
    setParameters(parameters.filter((_, i) => i !== index));
  };

  // Update specific parameter
  const updateParameter = (index, field, value) => {
    const updatedParameters = [...parameters];
    if (field.includes(".")) {
      const [parent, child] = field.split(".");
      updatedParameters[index][parent][child] = value;
    } else {
      updatedParameters[index][field] = value;
    }
    setParameters(updatedParameters);
  };

  const resetHandler = () => {
    // Reset new fields
    setLoincCodeValue(null);
    setName("");
    setCode("");
    setLoincCode("");
    setDescription("");
    setCategory(null);
    setPreparationInstructions("");
    setDuration("");
    setRequiresFasting(false);
    setSampleType("");
    setParameters([]);

    // Reset existing fields
    setOrderDate(new Date().toISOString().split("T")[0]);
    setTestDate(new Date().toISOString().split("T")[0]);
    setResultDate(new Date().toISOString().split("T")[0]);
    setResult("");
    setUnit("");
    setReferenceRange("");
    setSeverity(null);
    setComments("");
    setTestStatus(null);
    setUploadedFiles([]);

    // Reset new fields
    setPriority(null);
    setTestResult(null);
    setSelectedLabTestId(null);
  };

  useEffect(() => {
    if (selectedLabTestId) {
      getLabTestDetails();
    }
  }, [selectedLabTestId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveLabTestTemplateOffCanvas"
      aria-labelledby="saveLabTestTemplateOffCanvas"
    >
      {/* Header */}
      <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              science
            </span>
          </div>
          <div>
            <h3 className="offcanvas-title fw-bold text-white mb-0">
              Save Lab Test Template
            </h3>
            <p className="text-white fs-sm mb-0">
              Add or update lab test details
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
          {isLoadingData ? (
            <div className="animate-pulse">
              {/* Template Selection Skeleton */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="h-5 bg-gray-200 rounded w-1/4 mb-3 animate-pulse"></div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="h-4 bg-gray-200 rounded w-3/4 mb-2 animate-pulse"></div>
                    <div className="h-8 bg-gray-200 rounded animate-pulse"></div>
                  </div>
                  <div className="col-md-6">
                    <div className="h-4 bg-gray-200 rounded w-3/4 mb-2 animate-pulse"></div>
                    <div className="h-8 bg-gray-200 rounded animate-pulse"></div>
                  </div>
                </div>
              </div>

              {/* Basic Details Skeleton */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="h-5 bg-gray-200 rounded w-1/4 mb-3 animate-pulse"></div>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="h-4 bg-gray-200 rounded w-1/2 mb-2 animate-pulse"></div>
                    <div className="h-8 bg-gray-200 rounded animate-pulse"></div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="h-4 bg-gray-200 rounded w-1/2 mb-2 animate-pulse"></div>
                    <div className="h-8 bg-gray-200 rounded animate-pulse"></div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <div className="h-4 bg-gray-200 rounded w-1/3 mb-2 animate-pulse"></div>
                    <div className="h-8 bg-gray-200 rounded animate-pulse"></div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <div className="h-4 bg-gray-200 rounded w-1/4 mb-2 animate-pulse"></div>
                    <div className="h-20 bg-gray-200 rounded animate-pulse"></div>
                  </div>
                </div>
              </div>

              {/* Associated Persons Skeleton */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="h-5 bg-gray-200 rounded w-1/3 mb-3 animate-pulse"></div>
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <div className="h-4 bg-gray-200 rounded w-1/2 mb-2 animate-pulse"></div>
                    <div className="h-8 bg-gray-200 rounded animate-pulse"></div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="h-4 bg-gray-200 rounded w-1/2 mb-2 animate-pulse"></div>
                    <div className="h-8 bg-gray-200 rounded animate-pulse"></div>
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="h-4 bg-gray-200 rounded w-1/2 mb-2 animate-pulse"></div>
                    <div className="h-8 bg-gray-200 rounded animate-pulse"></div>
                  </div>
                </div>
              </div>

              {/* Parameters Skeleton */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="h-5 bg-gray-200 rounded w-1/4 animate-pulse"></div>
                  <div className="h-8 bg-gray-200 rounded w-24 animate-pulse"></div>
                </div>
                <div className="space-y-3">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="border rounded-8 p-3">
                      <div className="h-4 bg-gray-200 rounded w-1/3 mb-2 animate-pulse"></div>
                      <div className="row">
                        <div className="col-md-6 mb-2">
                          <div className="h-6 bg-gray-200 rounded animate-pulse"></div>
                        </div>
                        <div className="col-md-6 mb-2">
                          <div className="h-6 bg-gray-200 rounded animate-pulse"></div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Clinical Meta Data Skeleton */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="h-5 bg-gray-200 rounded w-1/4 mb-3 animate-pulse"></div>
                <div className="row">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="col mb-3">
                      <div className="h-4 bg-gray-200 rounded w-3/4 mb-2 animate-pulse"></div>
                      <div className="h-8 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                  ))}
                </div>
                <div className="row">
                  <div className="col">
                    <div className="h-4 bg-gray-200 rounded w-1/2 mb-2 animate-pulse"></div>
                    <div className="h-20 bg-gray-200 rounded animate-pulse"></div>
                  </div>
                </div>
              </div>

              {/* Action Button Skeleton */}
              <div className="group_btnOuter d-flex justify-content-end pt-3 border-top mt-auto">
                <div className="h-10 bg-gray-200 rounded w-32 animate-pulse"></div>
              </div>
            </div>
          ) : (
            <form onSubmit={(e) => e.preventDefault()}>
              {/* Basic Details Section - Updated */}

              <div className="mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <h5 className="mb-3 fw-semibold">{t("Template Details")}</h5>

                {/* LOINC Code Search */}
                <div
                  className={selectedLabTestId ? "d-none" : "form-group mb-4"}
                >
                  <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                    Test Name / Search LOINC
                  </label>
                  <AsyncSelect
                    styles={reactSelectStyle("3px", "6px", true, false)}
                    placeholder="Search LOINC"
                    loadOptions={loadLoincOptions}
                    defaultOptions={false}
                    cacheOptions={false}
                    value={loincCodeValue}
                    onChange={(val) => {
                      if (val) {
                        setLoincCodeValue(val);
                        setName(val.component);
                        setCode(val.loincNum);
                        setLoincCode(val.loincNum);
                      } else {
                        setLoincCodeValue(null);
                        setName("");
                        setCode("");
                        setLoincCode("");
                      }
                    }}
                    isClearable
                  />
                </div>

                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Template Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder="Enter Test Name"
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Test Code
                    </label>
                    <input
                      type="text"
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder="Enter Test Code"
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      LOINC Code
                    </label>
                    <input
                      type="text"
                      value={loincCode}
                      onChange={(e) => setLoincCode(e.target.value)}
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder="Enter LOINC Code"
                    />
                  </div>
                </div>

                <div className="form-group mb-4">
                  <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                    Test Type <span className="text-danger">*</span>
                  </label>
                  <AsyncSelect
                    loadOptions={loadCategoryOptions}
                    defaultOptions={true}
                    cacheOptions={false}
                    value={category}
                    onChange={setCategory}
                    isClearable
                    placeholder="Select Test Type (Blood, Urine, Imaging, etc.)"
                    styles={reactSelectStyle("3px", "6px", true, false)}
                  />
                </div>

                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Description
                    </label>
                    <textarea
                      rows="3"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder="Enter test description"
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Duration
                    </label>
                    <input
                      type="text"
                      value={duration}
                      onChange={(e) => setDuration(e.target.value)}
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder="e.g., 2-3 hours"
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Sample Type
                    </label>
                    <input
                      type="text"
                      value={sampleType}
                      onChange={(e) => setSampleType(e.target.value)}
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder="e.g., blood, urine"
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <div className="form-check mt-4">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="requiresFasting"
                        checked={requiresFasting}
                        onChange={(e) => setRequiresFasting(e.target.checked)}
                      />
                      <label
                        className="form-check-label ms-2 fw-semibold"
                        htmlFor="requiresFasting"
                      >
                        Requires Fasting
                      </label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      Preparation Instructions
                    </label>
                    <textarea
                      rows="3"
                      value={preparationInstructions}
                      onChange={(e) =>
                        setPreparationInstructions(e.target.value)
                      }
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder="Enter preparation instructions"
                    />
                  </div>
                </div>
              </div>

              {/* Test Parameters Section - Always visible */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0 fw-semibold">{t("Test Parameters")}</h5>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm d-flex align-items-center gap-1"
                    onClick={addParameter}
                  >
                    <span className="material-symbols-outlined">add</span>
                    <span>Add Parameter</span>
                  </button>
                </div>

                {parameters.length === 0 ? (
                  <div className="text-center py-4 text-muted">
                    <span className="material-symbols-outlined fs-1">
                      science
                    </span>
                    <p className="mb-0">
                      No parameters added yet. Click "Add Parameter" to start.
                    </p>
                  </div>
                ) : (
                  <>
                    {parameters.map((parameter, index) => (
                      <ParameterBlock
                        key={index}
                        parameter={parameter}
                        index={index}
                        updateParameter={updateParameter}
                        removeParameter={removeParameter}
                      />
                    ))}

                    {/* Add Parameter button at the bottom */}
                    <div className="d-flex justify-content-center mt-3">
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm d-flex align-items-center gap-1"
                        onClick={addParameter}
                      >
                        <span className="material-symbols-outlined">add</span>
                        <span>Add Another Parameter</span>
                      </button>
                    </div>
                  </>
                )}
              </div>

              <div className="group_btnOuter d-flex justify-content-end pt-3 border-top mt-auto">
                <button
                  type="button"
                  className="btn btn-primary d-flex align-items-center gap-2"
                  onClick={saveLabTestTemplateHandler}
                  disabled={isSaving}
                  style={{
                    cursor: isSaving ? "not-allowed" : "pointer",
                  }}
                >
                  {isSaving ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Saving...
                    </>
                  ) : (
                    <>
                      <span className="material-symbols-outlined me-1">
                        save
                      </span>
                      Save Template
                    </>
                  )}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>

      {/* Add CSS for glow animation */}
      <style jsx>{`
        @keyframes pulse {
          0%,
          100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }

        .animate-pulse {
          animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }

        .h-4 {
          height: 1rem;
        }
        .h-5 {
          height: 1.25rem;
        }
        .h-6 {
          height: 1.5rem;
        }
        .h-8 {
          height: 2rem;
        }
        .h-10 {
          height: 2.5rem;
        }
        .h-20 {
          height: 5rem;
        }
        .w-1\/2 {
          width: 50%;
        }
        .w-1\/3 {
          width: 33.333333%;
        }
        .w-1\/4 {
          width: 25%;
        }
        .w-3\/4 {
          width: 75%;
        }
        .w-24 {
          width: 6rem;
        }
        .w-32 {
          width: 8rem;
        }
        .space-y-3 > * + * {
          margin-top: 0.75rem;
        }
        .bg-gray-200 {
          background-color: #e5e7eb;
        }
      `}</style>
    </div>
  );
};

export default SaveLabTestTemplatePopup;
